import { LineIneligibilityReason } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import isEnumValue from '~utils/isEnumValue';

const lineIneligibilityReasonLabelKeys = {
  [LineIneligibilityReason.ALREADY_SETTLED]:
    'approvals.approve_charges.ineligibility.already_settled',
  [LineIneligibilityReason.INVOICE_VOIDED]:
    'approvals.approve_charges.ineligibility.invoice_voided',
  [LineIneligibilityReason.NOT_APPROVED]:
    'approvals.approve_charges.ineligibility.not_approved',
  [LineIneligibilityReason.REJECTED]: 'approvals.approve_charges.ineligibility.rejected',
  [LineIneligibilityReason.WORK_INCOMPLETE]:
    'approvals.approve_charges.ineligibility.work_incomplete',
} satisfies Record<LineIneligibilityReason, string>;

export function getLineIneligibilityReasonLabel(reason: string) {
  return t(
    isEnumValue(LineIneligibilityReason, reason)
      ? lineIneligibilityReasonLabelKeys[reason]
      : 'approvals.approve_charges.ineligibility.unknown',
  );
}
